import { PLUGINS as FULL_PLUGINS_LIST } from "molecules/PluginsList/plugins"
import ContentDiscord from "./content/discord.mdx"
import ContentGraves from "./content/graves.mdx"
import ContentHSRails from "./content/hsrails.mdx"
import ContentMcMMO from "./content/mcmmo.mdx"
import ContentShopGUIPlus from "./content/shop-gui.mdx"
import ContentShopGUIPlusSellGUI from "./content/shop-gui-sellgui.mdx"
import ContentTerraformGenerator from "./content/terraform-generator.mdx"
import ContentTheNewEconomy from "./content/tne.mdx"
import ContentStargates from "./content/stargates.mdx"
import ContentZeroInventoryProblemsZipBackpacks from "./content/zip.mdx"

export const PLUGINS_HELPER_ACCORDION_PLUGINS = FULL_PLUGINS_LIST.filter(plugin => plugin.interestingForUser)
export const PLUGIN_NAMES = PLUGINS_HELPER_ACCORDION_PLUGINS.map(plugin => plugin.name)

export type Keys = (typeof PLUGIN_NAMES)[number]

export type Plugin = {
  name: Keys | string
  contentElement: typeof ContentGraves
}

export type Plugins = Record<Keys, Plugin>

export const PLUGINS: Plugins = {
  "DiscordSRV": {
    name: "Discord",
    contentElement: ContentDiscord,
  },
  "Graves": {
    name: "Graves",
    contentElement: ContentGraves,
  },
  "HSRails": {
    name: "HSRails",
    contentElement: ContentHSRails,
  },
  "McMMO": {
    name: "McMMO",
    contentElement: ContentMcMMO,
  },
  "ShopGUIPlus": {
    name: "ShopGUIPlus",
    contentElement: ContentShopGUIPlus,
  },
  "ShopGUIPlus SellGUI": {
    name: "ShopGUIPlus SellGUI",
    contentElement: ContentShopGUIPlusSellGUI,
  },
  "TerraformGenerator": {
    name: "TerraformGenerator",
    contentElement: ContentTerraformGenerator,
  },
  "The New Economy": {
    name: "The New Economy",
    contentElement: ContentTheNewEconomy,
  },
  "Stargate": {
    name: "Stargate",
    contentElement: ContentStargates,
  },
  "Zero Inventory Problems Zip Backpacks": {
    name: "Zero Inventory Problems Zip Backpacks",
    contentElement: ContentZeroInventoryProblemsZipBackpacks,
  },
}
